module.exports = __webpack_public_path__ + "img/performance-1.12fc938f.png";